<div class="input-comment-tribe">
  <div class="input-comment-tribe__writer-area">
    <img
    [src]="urlImageProfileLogued?urlImageProfileLogued: '../../../../assets/images/user.png'"
     alt="user icon" width="10px" />
    <textarea
      type="text"
      [value]="comment"
      maxlength="300"
      (change)="onChange($event)"
      (keyup)="onChange($event)"
      placeholder="Comienza a interactuar en tu tribu con un aporte o pregunta"
    ></textarea>
  </div>
  <small class="pl-3"  style="color: rgb(177, 176, 176);
    padding-right: 6px; display: flex; justify-content: flex-end;
  " >{{ comment.length }} / 300</small>
  <div class="input-comment-tribe__foot-send">
    <button (click)="onPublish()" >{{ buttonText }}  </button>
  </div>
</div>
